import styled from 'styled-components';

export const RoomActions = styled.div`
  text-align: right;
  padding-bottom: 8px;
  margin-top: 3rem;
`;

export const StyledRoomSearchResult = styled.div`
  .room-image {
    max-width: 100%;
    width: 100%;
  }
`;

export const StyledSearchContent = styled.div`
  flex: 1;
`;

export const StyledSearchGrid = styled.div`
  display: flex;
`;
